import request from "./http";
import util from "./util";

// 公众号二维码
export function wechatQrcode(data) {
  return request({
    url: "wechat/qrcode",
    method: "get",
    params: util.json2formData(data)
  });
}

//UrlLink
export function getMiniUrlLink(data) {
  return request({
    url: "wechat/getMiniUrlLink",
    method: "get",
    params: util.json2formData(data)
  });
}

//UrlLink
export function getUrlLinkByCode(data) {
  return request({
    url: "wechat/getUrlLinkByCode",
    method: "get",
    params: util.json2formData(data)
  });
}

// 扫描轮询
export function pollingBind(data) {
  return request({
    url: "qrcodelogin",
    method: "post",
    params: util.json2formData(data)
  });
}

// 刷新token
export function refresh(data) {
  return request({
    url: "my/refresh",
    method: "get",
    params: util.json2formData(data)
  });
}


// 小程序二维码
export function xcxQrcode(data) {
  return request({
    url: "wechat/miniprogramqrcode",
    method: "get",
    params: util.json2formData(data),
    responseType: "blob"
  });
}

// 获取个人信息
export function userInfo(){
  return request({
    url:"my/info",
    method:"get"
  })
}

// 获取全部信息
export function userallInfo(){
  return request({
    url:"my/userinfo",
    method:"get"
  })
}

// 获取用户身份
export function identity(){
  return request({
    url:"my/identity",
    method:"get"
  })
}

// 获取项目列表
export function works(data) {
  return request({
    url: "deliver/works",
    method: "get",
    params: util.json2formData(data)
  });
}

// 获取客户行业
export function customerIndustries() {
  return request({
    url: "PhotographerWorkCustomerIndustries",
    method: "get"
  });
}


// 获取作品类型
export function workCategories() {
  return request({
    url: "photographerWorkCategories",
    method: "get"
  });
}

// 上传图片，获取七牛的参数
export function qiniuGetParams() {
  return request({
    url: "qiniu/getParams",
    method: "get"
  });
}

// 创建项目
export function createPro(data) {
  console.log(data)
  return request({
    url: "deliver/works",
    method: "POST",
    data:data
  });
}

// 短信提醒
export function obtainremind(data) {
  return request({
    url: "deliver/works/obtainremind",
    method: "POST",
    data:data
  });
}

// 进入项目详情
export function getDetails(data){
  return request({
    url:'deliver/works/'+ data,
    method: "get"
  })
}

// 删除项目
export function deleteDetails(data){
  return request({
    url:'deliver/works/'+ data,
    method: "delete"
  })
}

// 进入下级目录
export function filelist(params) {
   return request({
     url:'deliver/works/filelist',
     method:'get',
     params:params
   })
}

// 判断百度授权
export function isOauth(params) {
  return request({
    url:'baidu/isOauth',
    method:'get',
    params:params
  })
}

// 提取码
export function obtain(params) {
  return request({
    url:'deliver/works/obtain',
    method:'post',
    data:params
  })
}

// 下载次数
export function downUp(params){
  return request({
    url:'delivery/works/obtaintolocal',
    method:'POST',
    data:params
  })
}

// 获取个人信息
export function downloadAllImg(){
  return request({
    url:"my/downloadAllImg",
    method:"get"
  })
}

// -----------------------超爽整理工具---------------------

// 添加项目图片
export function addPhotographerWorkSource(params) {
  return request({
    url:'my/addPhotographerWorkSource',
    method:'post',
    data:params
  })
}

// 添加信息
export function addPhotographerWork(params) {
  return request({
    url:'my/addPhotographerWork',
    method:'post',
    data:params
  })
}

// 验证非法字符
export function wordcheck(params){
  return request({
    url:'/wordcheck',
    method:"get",
    params:params
  })
}

// 消息推送
export function sendPhotographerWorkInfo(params){
  return request({
    url:'my/sendPhotographerWorkInfo',
    method:"post",
    params:params
  })
}


// 公众号二维码
export function wxJsAuth(data) {
  return request({
    url: "payment/wxJsAuth",
    method: "get",
    params: data
  });
}

// js支付
export function wxJsPay(data) {
  return request({
    url: "payment/wxJsPay",
    method: "post",
    params: data
  });
}

// h5支付
export function wxH5Pay(data) {
  return request({
    url: "payment/wxH5Pay",
    method: "post",
    params: data
  });
}

// 二维码支付
export function wxQrCodePay(data) {
  return request({
    url: "payment/wxQrCodePay",
    method: "post",
    params: data
  });
}



// 帮助明细
export function getHelpNotes(data) {
  return request({
    url: "getHelpNotes_n",
    method: "get",
    params: data
  });
}

// 帮助明细
export function getHelpNoteDetail(data) {
  return request({
    url: "sys/getHelpNoteDetail",
    method: "get",
    params: data
  });
}

//密钥登录
export function secretLogin(data) {
  return request({
    url: "secretLogin",
    method: "post",
    params: data
  });
}

// 摄影师信息
export function grapherinfo(data) {
  return request({
    url: "photographer/info", //获取摄影师的信息
    method: 'get',
    params: data
  });
}


//计算支付金额
export function calcOrderAmt(data) {
  return request({
    url: "payment/calcOrderAmt", 
    method: 'post',
    params: data
  });
}
/*
// 活动
export function checkActiveSetting(data) {
  return request({
    url: "payment/checkActiveSetting",
    method: "get",
    params: data
  });
}
*/
// 折扣
export function getActiveDiscount(data) {
  return request({
    url: "payment/getActiveDiscount",
    method: "get",
    params: data
  });
}

